import React from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import { Layout, Typography, Localization } from 'connex-cds';

const { Subtitle } = Typography;
const { Translate } = Localization;
const { Column, Container } = Layout;

const Styled = styled(Column)`
  & > * {
    &:not(:first-child) {
      margin-top: 10px;
    }
  }

  .dynamic-waiver-mobile-container {
    padding: 5px 10px;
  }

  .dynamic-waiver-section-mobile {
    padding: 5px;
  }

  [data-testid='dynamicWaiverValue'] {
    textarea {
      height: 70px;
      width: 100%;
      border: 0;
      background: transparent;
    }
  }
`;

export const DynamicWaiverMobile = ({ showField }) => {
  const field = showField();

  return (
    <Styled className={cn('dynamic-waiver')}>
      <Column>
        <Container flex={1} className={cn('dynamic-waiver-mobile-container')}>
          <Subtitle>
            <Translate stringId="dynamicWaiver" data-testid="dynamicWaiverLabel" />
          </Subtitle>
          <div className={cn('dynamic-waiver-section-mobile')}>
            <div data-testid="dynamicWaiverValue">{field}</div>
          </div>
        </Container>
      </Column>
    </Styled>
  );
};
